<header class="legal-topbar">
  <span class="brand-mark" aria-hidden="true">P</span>
  <nav class="legal-nav" aria-label="Legal pages">
    <a routerLink="/privacy-policy" routerLinkActive="active" class="admin-nav-link">Privacy Policy</a>
    <a routerLink="/end-user-license-agreement" routerLinkActive="active" class="admin-nav-link">EULA</a>
  </nav>
</header>

<div class="legal-page">
  <div class="legal-overline">Legal</div>
  <h1>Privacy Policy</h1>
  <p class="legal-updated">Last updated August 1, 2026</p>

  <div class="content-section">
    <h5>Information We Collect</h5>
    <p>
      We collect personal information such as your name, email address, and
      billing information when you use Paierly.
    </p>

    <h5>Use of Information</h5>
    <p>
      We use the information collected to provide and improve our service,
      process payments, and communicate with you.
    </p>

    <h5>Sharing Data</h5>
    <p>
      We do not share your personal information with third parties except as
      necessary to provide the service (e.g., QuickBooks) or as required by law.
    </p>

    <h5>Data Protection</h5>
    <p>
      We implement reasonable security measures to protect your personal
      information against unauthorized access, alteration, disclosure, or
      destruction.
    </p>

    <h5>Access and Control of Your Data</h5>
    <p>
      You may access, correct, or delete your personal information by contacting
      us at <a href="mailto:intuit@solvisse.com">intuit&#64;solvisse.com</a>.
    </p>

    <h5>Changes to the Privacy Policy</h5>
    <p>
      We reserve the right to modify this Privacy Policy at any time. We will
      notify you of any material changes through the application or by other
      reasonable means.
    </p>

    <h5>Contact</h5>
    <p>
      If you have any questions about this Privacy Policy, you can contact us at
      <a href="mailto:intuit@solvisse.com">intuit&#64;solvisse.com</a>.
    </p>
  </div>

  <div class="legal-footer text-caption">
    <p>&copy; 2024 Paierly. All rights reserved.</p>
  </div>
</div>
